import { ReferralStatus } from "@src/gql/graphql";
import getFormattedDate from "@src/utils/getFormattedDate";

export function formatRewardExpiryDate(dateString: string) {
	const date = new Date(dateString);

	return date.toLocaleDateString("en-US", {
		month: "short",
		day: "numeric",
		year: "numeric",
	});
}

export function getReferralStatusMeta(status: ReferralStatus) {
	switch (status) {
		case ReferralStatus.Registered:
			return {
				label: "Registered",
				className: "bg-amber-50 text-amber-700",
			};
		default:
			return {
				label: "Activated",
				className: "bg-emerald-50 text-emerald-700",
			};
	}
}

export function getRegisteredDateText(registeredAt: string | null) {
	if (!registeredAt) {
		return "Not registered";
	}

	return getFormattedDate(registeredAt, "localymd");
}
